import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { StyledTextField } from "../StyledComponents";

export default function SectionTextForm({ values, setValues }) {
  const handleChange = (field) => (e) => {
    let val = e.target.value;
    if (field === "priority") val = val.replace(/\D/g, "");
    setValues((prev) => ({ ...prev, [field]: val }));
  };

  return (
    <Stack spacing={3} direction="column" alignItems="left">
      <Typography
        variant="h1"
        align="center"
        fontSize={22}
        fontFamily="Trueno Light"
      >
        1. Main Info
      </Typography>
      <StyledTextField
        label="Section Title"
        placeholder="Enter Section title"
        value={values.title}
        onChange={handleChange("title")}
        fullWidth
        slotProps={{ htmlInput: { maxLength: 200 } }}
      />
      <StyledTextField
        label="Section Subtitle"
        placeholder="Enter Section subtitle"
        value={values.subtitle}
        onChange={handleChange("subtitle")}
        fullWidth
        slotProps={{ htmlInput: { maxLength: 300 } }}
      />
      <StyledTextField
        label="Section Text"
        placeholder="Enter Section text"
        value={values.text}
        onChange={handleChange("text")}
        fullWidth
        slotProps={{ htmlInput: { maxLength: 2500 } }}
      />
      <StyledTextField
        label="Section Priority"
        placeholder="Enter Section priority"
        value={values.priority}
        onChange={handleChange("priority")}
        fullWidth
        slotProps={{ htmlInput: { maxLength: 4 } }}
      />
    </Stack>
  );
}
